import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { MOBILE } from '../guided-toolbox/utils/breakpoints'

export const Spacer = styled.div`
  padding: ${p => p.space};
`

export const ContentBox = styled.div`
  max-width: 800px;
  margin: auto;
  padding: 10px 15px;
`

const rowMedia = css`
  flex-wrap: wrap;
`

const row = css`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.8s;
  @media (max-width: 800px) {
    ${rowMedia};
  }
`

export const Row = styled.div`
  ${row};
`

export const RowDrawer = styled.div`
  ${row};
  flex-wrap: wrap;
`

export const QuestionText = styled.div`
  color: #9eacb0;
  font-size: 1.125rem;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
`

export const Text = styled.div`
  color: ${p => p.theme.cardViewValueColor};
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: ${p => (p.fontSize ? p.fontSize : '1.125rem')};
  line-height: 1.35;
  padding: ${p => (p.padding ? p.padding : null)};
  word-break: break-word;
`

export const OrderedList = styled.ol`
  padding-left: 22px;
  li {
    padding-left: 30px;
  }
`

export const InputBox = styled.div`
  flex: 3 1 340px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 10px;
  > * {
    padding-right: ${p => (p.childrenPadding ? p.childrenPadding : '')};
  }

  @media (max-width: 800px) {
    padding-top: 8px;
    padding-left: 0;
    ${p => p.styledMedia800 || ''};
  }
`

/**
 * Displays page actions side by side at equal height on desktop and stacks them full-width on
 * mobile, reversing their order unless `preserveOrder` is set.
 */
export const ButtonsBox = styled.div`
  display: flex;
  justify-content: ${p => p.justifyContent ?? 'space-between'};
  align-items: stretch;
  max-width: ${p => (p.maxWidth ? p.maxWidth : '1200px')};
  gap: 16px;
  margin: 70px auto;

  ${MOBILE} {
    flex-direction: ${p => (p.preserveOrder ? 'column' : 'column-reverse')};
    margin: 50px auto;
  }
`

const HELP_ICON_GUTTER = '32px'

export const ButtonWithHelpIcon = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;

  & > button {
    flex: 1;
    width: auto;
  }
`

/* Reserve the help-icon gutter on unpaired buttons so every button aligns in a mobile stack. */
export const helpIconGutter = css`
  & > button {
    width: auto;
    margin-right: ${HELP_ICON_GUTTER};
  }
`

export const InlineLink = styled.a`
  cursor: pointer;
  color: #1f97be;
  text-decoration: ${p => (p.noUnderline ? '' : 'underline')};
`

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${p => (p.justifyContent ? p.justifyContent : null)};
  align-items: ${p => (p.alignItems ? p.alignItems : 'center')};
  flex-wrap: ${p => (p.wrap ? p.wrap : 'wrap')};
  max-width: ${p => (p.maxWidth ? p.maxWidth : null)};
  margin: ${p => (p.childMargin ? '0 -8px' : null)};

  & > * {
    margin: ${p => (p.childMargin ? '0 8px' : null)};
  }
`

export const TextSpan = styled.span`
  display: inline-block;
`

export const Container = styled.div`
  max-width: ${p => (p.maxWidth ? p.maxWidth : '1200px')};
  margin: ${p => (p.margin ? p.margin : '0 auto')};
  padding: ${p => (p.padding ? p.padding : null)};
  min-width: ${p => (p.minWidth ? p.minWidth : null)};
`

export const MainTitle = styled.div`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 3rem;
  ${p => (p.maxWidth ? p.maxWidth : null)};
  color: ${p => p.theme.mediumGray};
  font-weight: 300;
  line-height: 1.25;
  transition: 0.25s;
  word-wrap: break-word;
  white-space: pre-wrap;

  @media (max-width: 800px) {
    font-size: ${p => (p.shrink ? '2rem' : null)};
  }
`
